import { useCallback } from "react";

import { useAPIFetch } from "./use-api-fetch";

export function useDeleteTranscript(): (id: string) => Promise<Response> {
  const apiFetch = useAPIFetch();

  const deleteTranscript = useCallback(
    async (id: string) =>
      apiFetch.execute(`/api/v2/transcription/${id}`, { method: "DELETE" }),
    [apiFetch],
  );

  return deleteTranscript;
}
